<script lang="ts" setup>
import type { Component } from 'vue'
import { NavigationProfile, UserLogin } from '#components'

const pb = useNuxtApp().$pb
const { data: navigation, status, error } = await useAsyncData(
  'main-navigation-main',
  async () => await pb.collection<NavigationItem>('navigations').getFullList({ sort: 'order', expand: 'page', fields: '*,expand.page.slug', filter: 'navigationType = "main"', requestKey: 'main' }),

  {
    transform: data => generateNavigation(data),
  },
)

const { loggedIn } = useUser()
const { name = '' }: { name?: string } = useRuntimeConfig().public
const route = useRouter()
const slug = computed(() => route.currentRoute.value.fullPath as string)
const open = ref(false)

watch(slug, () => {
  open.value = false
}, { deep: true })
</script>

<template>
  <div
    class="w-full px-3 md:px-4 lg:px-6 py-2 flex items-center justify-between fixed  top-0 shadow-lg z-50 bg-white rounded-bl-full "
  >
    <NuxtLink
      to="/"
      aria-label="Homepage"
    >
      <NuxtPicture
        src="/GBF-Logo.png"
        :img-attrs="{ class: 'h-8 md:h-12 xl:h-16 w-auto object-contain' }"
        :alt="name"
      />
    </NuxtLink>
    <NavigationBase
      :navigation="navigation"
      class="hidden lg:flex"
    />
    <div class="flex items-center gap-2 lg:hidden">
      <button
        aria-label="Open Menu"
        @click="open = !open"
      >
        <Icon
          name="ri:menu-3-fill"
          class="text-lg"
        />
      </button>
      <NavigationNotification />
    </div>
    <USlideover
      v-model="open"
      class="lg:hidden"
    >
      <div class="gap-3 flex flex-col p-6 h-full">
        <div class=" flex-col flex flex-1">
          <button
            class="ml-auto self-end mb-3"
            @click="open = false"
          >
            <Icon name="ri:close-line" />
          </button>

          <template
            v-for="item in navigation"
            :key="item.id"
          >
            <NuxtLink
              v-if="!item?.children?.length"
              :to="item.expand?.page?.slug"
              exact-active-class="active"
              class="link mb-3"
            >
              {{ item.label }}
            </NuxtLink>
            <template v-else>
              <NuxtLink
                v-if="item?.expand?.page?.slug"
                :to="item.expand.page.slug"
                class="link"
              >
                {{ item.label }}
              </NuxtLink>
              <p
                v-else
                class="n link"
              >
                {{ item.label }}
              </p>
              <ul class="pl-2 mb-4">
                <li
                  v-for="navItem in item.children"
                  :key="navItem.id"
                >
                  <NuxtLink
                    :to="navItem.expand?.page?.slug"
                    class="link"
                  >
                    {{ navItem.label }}
                  </NuxtLink>
                </li>
              </ul>
            </template>
          </template>

          <NuxtLink
            v-if="!loggedIn"
            to="/login"
            class="link"
          >
            Login
          </NuxtLink>
          <NavigationProfile
            v-else
            class="pt-3"
          />
        </div>
        <div class="ml-auto">
          <SearchGeneral />
        </div>
      </div>
    </USlideover>
  </div>
</template>

<style scoped>
.link {
  @apply inline-flex items-center text-primary-700 font-display lg:text-lg hover:bg-primary-700 hover:text-yellow uppercase font-bold rounded-full px-2 py-1 md:px-3 lg:px-4 duration-100;
}

.link.active {
  @apply text-pink hover:bg-transparent;
}

.n.link {
  @apply hover:bg-transparent hover:text-primary-500 text-primary-500 pb-0;
}
</style>
